import { useEffect, useSyncExternalStore } from 'react';
import { todayUk } from '@nu/shared';
import { api } from '../../api/client.js';

// Your tasks, shared by the Tasks page and the sidebar's badge (due today or
// overdue). Loaded once, then every minute while the tab is in front, and
// straight after every change.
let state = { tasks: null, lists: [], status: 'idle' };
const listeners = new Set();
const emit = () => listeners.forEach((l) => l());
const set = (patch) => { state = { ...state, ...patch }; emit(); };

let loading = null;
export function reloadTasks() {
  if (loading) return loading;
  set({ status: state.tasks ? 'ok' : 'loading' });
  loading = api('/tasks').then(
    (r) => set({ tasks: r.tasks, lists: r.lists, status: 'ok' }),
    () => set({ status: 'error' }),
  ).finally(() => { loading = null; });
  return loading;
}

// Change something, show it straight away, then reload from the server.
export async function changeTask(id, patch) {
  if (state.tasks) set({ tasks: state.tasks.map((t) => (t.id === id ? { ...t, ...patch } : t)) });
  try {
    await api(`/tasks/${id}`, { method: 'PUT', body: patch });
  } finally {
    await reloadTasks();
  }
}

const subscribe = (l) => { listeners.add(l); return () => listeners.delete(l); };
let users = 0;
export function useTasks() {
  const snap = useSyncExternalStore(subscribe, () => state);
  useEffect(() => {
    users += 1;
    if (!state.tasks && !loading) reloadTasks();
    const tick = () => { if (document.visibilityState === 'visible') reloadTasks(); };
    const every = users === 1 ? setInterval(tick, 60_000) : null;
    window.addEventListener('focus', tick);
    return () => { users -= 1; if (every) clearInterval(every); window.removeEventListener('focus', tick); };
  }, []);
  return snap;
}

export const isDue = (t, today = todayUk()) => !t.done && t.dueDate && t.dueDate <= today;
export function useTasksDue() {
  const { tasks } = useTasks();
  const today = todayUk();
  return (tasks || []).filter((t) => isDue(t, today)).length;
}
